import axios from 'axios';

import { getAuthorizationHeaders } from './helpers/authHelpers';

axios.interceptors.request.use((config) => {
	config.headers = { ...getAuthorizationHeaders(), ...config.headers };
	return config;
});

axios.interceptors.response.use(undefined, (error) => {
	const statusCode = error.response?.status;

	if (statusCode === 401) {
		sessionStorage.clear();
		window.dispatchEvent(new Event('jwt'));
	}
	return Promise.reject(error);
});
